export default __webpack_public_path__ + "static/media/5hl8i764o3f1rc624qos5ukags.31c0e97d.png";